(function ($, Drupal) {
  // eslint-disable-next-line no-param-reassign
  Drupal.behaviors.copd = {
    attach: function attach(context, settings) {
      // @todo: Fix issue with js being added onto page twice, .once function maybe?
      $(document).on('click', '#fake-submit', function (e) {
        e.preventDefault();

        if (!$(this).hasClass('is-disabled')) {
          // Submitting the form here loads the previous form page.
          $('form.webform-submission-your-copd-passport-form .button.form-submit').click();
        }
      });
    }
  };
})(jQuery, Drupal);